/* unplugin-vue-components disabled */import script from "./UserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=14fbcd33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fbcd33"]])

export default __exports__